import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea8fa44c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title mb-4" }
const _hoisted_3 = { class: "description mb-4" }

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Emits = {
  (event: 'on-confirm'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestError',
  emits: ["on-confirm"],
  setup(__props, { emit: __emit }) {

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, { class: "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SvgIcon, {
              class: "mb-4",
              name: "up-error",
              color: "var(--neutral-20)",
              width: "150",
              height: "150"
            }),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modal.request_error.title')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modal.request_error.description')), 1 /* TEXT */),
            _createVNode(Button, {
              variant: "primary",
              "is-full-width": true,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('on-confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('import_waiting.confirm')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})